import { Layout } from '../../components/front'
import { getProductCategories, getStaticDate } from '../../lib'

export async function getServerSideProps() {
    const productCategories = await getProductCategories()
    const data = await getStaticDate()
    return { props: { productCategories: productCategories, footer: data['about_footer'].content } }
}

export default function Faq({ productCategories, footer }) {
    return (
        <Layout menu={productCategories} footer={{ about: footer }}>
            <div className="p-8">
                <div className="bg-white p-30 rounded">
                    <div className="p-50">
                        <div>
                            <section className="text-gray-700">
                                <div className="container px-5 py-24 mx-auto">
                                    <div className="text-center mb-20">
                                        <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
                                            سوالات پرتکرار
                                        </h1>
                                        <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                                            اینجا سوالاتی رو که زیاد از ما میپرسن رو پاسخ دادیم تا شما راحتتر بتونید به جواب سوالاتتون برسید
                                        </p>
                                    </div>
                                    <div className="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
                                        <div className="w-full lg:w-1/2 px-4 py-2">
                                            <details className="mb-4">
                                                <summary className="font-semibold bg-gray-200 rounded-md py-2 px-4">
                                                    آیا خرید حضوری دارید؟ آیا امکان مراجعه و تحویل حضوری وجود دارد؟
                                                </summary>

                                                <span>
                                                    خیر ، فروشگاه کاج یک فروشگاه اینترنتی است و امکان مراجعه ، تحویل و خرید حضوری وجود
                                                    ندارد.
                                                </span>
                                            </details>
                                            <details className="mb-4">
                                                <summary className="font-semibold bg-gray-200 rounded-md py-2 px-4">
                                                    اگر در زمان مراجعه ی تحویل بسته (پیک و پست) حضور نداشته باشیم ، چه اتفاقی می افتد؟
                                                </summary>

                                                <span>
                                                    در صورتی که مامور پست و یا پیک به آدرس شما مراجعه کند و شما در آدرس مذکور حضور نداشته
                                                    باشید ، بسته ی شما برگشت میخورد. هزینه ارسال مجدد با مشتری بوده (هزینه پست یا پیک) و پس
                                                    از واریز ،دوباره بسته ارسال می شود و اگر مجدد حضور نداشته باشید این روند تکرار می شود.
                                                </span>
                                            </details>
                                            <details className="mb-4">
                                                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                                                    پس از ثبت سفارش چطور میتوانم سفارشم را پیگیری کنم؟
                                                </summary>

                                                <span>
                                                    در صورتی که پس از هفت روز کاری سفارشتان به دستتان نرسید به تلگرام یا واتس اپ یکی از
                                                    شماره های ذکر شده پیام دهید.
                                                </span>
                                            </details>
                                        </div>
                                        <div className="w-full lg:w-1/2 px-4 py-2">
                                            <details className="mb-4">
                                                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                                                    پس از ثبت سفارش نهایی ، چه مدت طول می کشد تا سفارشم را دریافت کنم؟
                                                </summary>

                                                <span className="px-4 py-2">
                                                    <p>
                                                        <p className="font-bold">شیوه ارسال سفارشات تهران:</p>
                                                        سفارشات داخل شهر تهران به انتخاب مشتری با پست یا پیک موتوری ارسال میشود. ارسال با
                                                        پست حدودا ۲ الی ۵ روز کاری زمان میبرد تا به مقصد برسد. بسته های پُستی در ساعات اداری
                                                        تحویل داده میشوند. ارسال با پیک موتوری فقط برای داخل تهران (نه حومه و اطراف) صورت
                                                        میگیرد و روز کاری بعد از ثبت سفارش ارسال میشود. ساعات تحویل بسته های پیکی بین ساعت ۱
                                                        ظهر تا ۹ شب (۱۳ الی ۲۱) میباشد و امکان تعیین ساعت دقیق وجود ندارد.
                                                    </p>
                                                    <p className="font-bold">شیوه ارسال سفارشات شهرستان:</p>
                                                    <p>
                                                        تمامی سفارشات شهرستان و حومه تهران فقط با پست پیشتاز ارسال میشوند و حدودا ۳ الی ۷
                                                        روز کاری زمان میبرد تا به مقصد برسند. بسته های پستی در ساعات اداری تحویل مشتری داده
                                                        میشوند.
                                                    </p>
                                                    <p>
                                                        ارسال بسته ها فقط روز های شنبه تا چهارشنبه انجام میشود و پنجشنبه و جمعه ها و روزهای
                                                        تعطیل ارسال نداریم. بنابراین سفارشاتی که در روزهای چهارشنبه ثبت شوند، تحویلشان به
                                                        پست و پیک روز کاری بعد یعنی شنبه انجام میگیرد.
                                                    </p>
                                                    <p>
                                                        با توجه به حجم بالای سفارشات ، زمان اعلام شده برای تحویل بسته ها حدودی بوده و احتمال
                                                        وجود کمی تاخیر در تحویل بسته ها امری طبیعی هست.
                                                    </p>
                                                </span>
                                            </details>
                                            {/* <details className="mb-4">
                                                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                                                    How many sites I can create
                                                    at once?
                                                </summary>

                                                <span className="px-4 py-2">
                                                    Laboris qui labore cillum
                                                    culpa in sunt quis sint
                                                    veniam. Dolore ex aute
                                                    deserunt esse ipsum elit
                                                    aliqua. Aute quis minim
                                                    velit nostrud pariatur culpa
                                                    magna in aute.
                                                </span>
                                            </details>
                                            <details className="mb-4">
                                                <summary className="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                                                    How can I communicate with
                                                    you?
                                                </summary>

                                                <span className="px-4 py-2">
                                                    Laboris qui labore cillum
                                                    culpa in sunt quis sint
                                                    veniam. Dolore ex aute
                                                    deserunt esse ipsum elit
                                                    aliqua. Aute quis minim
                                                    velit nostrud pariatur culpa
                                                    magna in aute.
                                                </span>
                                            </details> */}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
